import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { emsBadge, emsBadgeLogEntry, emsBadgeLogs } from 'src/models/emsModels';
import { NotificationBar } from 'src/services/notification.service';
import { environment } from 'src/environment';
import { ConfirmDialogDialog } from '../confirm-dialog/confirm-dialog.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-badge-meal-counter',
  templateUrl: './badge-meal-counter.component.html',
  styleUrl: './badge-meal-counter.component.scss'
})
export class BadgeMealCounterComponent {

  notificationBar: NotificationBar;
  workspaceID = "";
  badgeList = new Array<emsBadge>();
  displayedColumns: string[] = ['date', 'aaa', 'crew', 'visitor' , 'creator', 'security', 'voucher', 'other', 'total', 'delete'];
  mealCounterSource = new MatTableDataSource<emsBadgeLogs>;
  searchValue: string;
  badgesMealsDBRef: any;
  badgesRegistryDBRef: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private title: Title, private location: Location, private snackBar: MatSnackBar, public dialog: MatDialog, private db: AngularFireDatabase) {
    this.notificationBar = new NotificationBar(snackBar);
   }

  ngOnInit() {  
    this.workspaceID  = this.location.path().split("/")[1];
    this.title.setTitle("Meal Counter - EsportsMS");
    this.loadBadges();
  }

  ngOnDestroy() {
    if (this.badgesMealsDBRef) {
      this.badgesMealsDBRef.off('value');
    };
    if (this.badgesRegistryDBRef) {
      this.badgesRegistryDBRef.off('value');
    };
  }

  mealCounterSearch(event: Event) {
    this.searchValue = (event.target as HTMLInputElement).value;
    this.mealCounterSource.filter = this.searchValue.trim().toLowerCase();
  }

  loadMeals() {
    this.badgesMealsDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/badges/' + this.workspaceID + '/meals');
    this.badgesMealsDBRef.on('value', x => {
      const rawData = x.toJSON();
      var badgeLogList = new Array<emsBadgeLogs>();
      Object.keys(rawData).forEach(key => { 
        var badgeLogEntries = Object.values(rawData[key]) as Array<emsBadgeLogEntry>;
        var badgeLogs = new emsBadgeLogs();
        var dateString = key;
        var [day, month, year] = dateString.split("-").map(num => parseInt(num, 10));
        var dateObject = new Date(year, month - 1, day);
        badgeLogs.date = dateObject;
        badgeLogs.total = badgeLogEntries.length;
        var emsBadgeList = this.badgeList.filter(badge => badgeLogEntries.some(logEntry => logEntry.uid == badge.uid && badge.type == "AAA"));
        badgeLogs.aaa = emsBadgeList.length;
        var emsBadgeList = this.badgeList.filter(badge => badgeLogEntries.some(logEntry => logEntry.uid == badge.uid && badge.type == "RGA Crew"));
        badgeLogs.crew = emsBadgeList.length;
        var emsBadgeList = this.badgeList.filter(badge => badgeLogEntries.some(logEntry => logEntry.uid == badge.uid && badge.type == "Visitor"));
        badgeLogs.visitor = emsBadgeList.length;
        var emsBadgeList = this.badgeList.filter(badge => badgeLogEntries.some(logEntry => logEntry.uid == badge.uid && badge.type == "Creator"));
        badgeLogs.creator = emsBadgeList.length;
        var emsBadgeList = this.badgeList.filter(badge => badgeLogEntries.some(logEntry => logEntry.uid == badge.uid && badge.type == "Security"));
        badgeLogs.security = emsBadgeList.length;
        var emsBadgeList = this.badgeList.filter(badge => badgeLogEntries.some(logEntry => logEntry.uid == badge.uid && badge.type == "Food Voucher"));
        badgeLogs.voucher = emsBadgeList.length;
        badgeLogs.other = badgeLogs.total - badgeLogs.aaa - badgeLogs.crew - badgeLogs.visitor - badgeLogs.creator - badgeLogs.security - badgeLogs.voucher;
        badgeLogList.push(badgeLogs);
      });
      badgeLogList.sort((a, b) => b.date.getTime() - a.date.getTime());
      this.mealCounterSource = new MatTableDataSource(badgeLogList);
      this.mealCounterSource.sort = this.sort;
      this.mealCounterSource.paginator = this.paginator;
    });
  }

  loadBadges() {
    this.badgesRegistryDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/badges/' + this.workspaceID + '/registry');
    this.badgesRegistryDBRef.on('value', x => {
      const rawData = x.toJSON(); // different because /player is an list, for object I would need /player/{teamID}
      this.badgeList = new Array<emsBadge>();
      Object.keys(rawData).forEach(key => { 
        var badge = rawData[key] as emsBadge;
        badge.uid = key;
        this.badgeList.push(badge);
      });
      this.loadMeals();
    });
  }

  async deleteLog(logsDate: Date) {
    var day = String(logsDate.getDate()).padStart(2, "0");
    var month = String(logsDate.getMonth() + 1).padStart(2, "0");
    var year = logsDate.getFullYear();
    var badgeLogsDate = day + "-" + month + "-" + year;
    var dialogRef = this.dialog.open(ConfirmDialogDialog, {
          data: {
            actionType: "delete",
            message: "Are you sure you want to delete all logs for the " + badgeLogsDate + "?",
          }
        });
        return dialogRef.afterClosed().toPromise().then(async res => {
          if (res == true) {
            this.db.database.app.database(environment.emsDatabaseURL).ref('/badges/' + this.workspaceID + '/meals/' + badgeLogsDate).remove().then( x => {
              this.notificationBar.show("Logs deleted!");
            }, err => {
                this.notificationBar.showUnknownError();
            })
          }
        });
  }
}
